import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/ShareModal.css';
import { useState } from 'react';
import { FaArrowRight } from "react-icons/fa";

export default function ShareWordsModal( {
    show,
    onClose,
    fromIndex,
    project,
    fromWords,
    toTransfer,
    toIndex,
    setToIndex,
    wordsToTransfer,
    setWordsToTransfer
} ) {
    if (!show || show === false || fromIndex === null) return null;

const chapter = project.chapters[fromIndex];



    return (
            <div className="modal fade show d-block" id="ShareWordsModal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">Przekazanie słów</h5>
                        <button 
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                        >
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="transfer-container"> 
                            <div className="chapter-box"> 
                                <p className="chapter-title"> {chapter.title} </p>
                                <p className="chapter-words"> {fromWords} 
                                {wordsToTransfer > 0 && <> →  {fromWords - wordsToTransfer} </>}
                                </p>
                            </div>

                            
                            <FaArrowRight  className="arrow"/>
                            <div className="chapter-box"> 
                                <select
                                className="chapter-title"
                                onChange={(e) => { 
                                setToIndex(Number(e.target.value))
                                }}>
                                <option value="">— wybierz rozdział —</option>
                                {project.chapters.map((chapter, i) => (
                                    i !== fromIndex && (
                                        <option key={i} value={i}> {chapter.title} </option>
                                    )
                                ))}
                            </select>
                            {toIndex != null && (
                                <p className="chapter-words"> {project.chapters[toIndex].words} 
                                {wordsToTransfer > 0 && <> → {project.chapters[toIndex].words + wordsToTransfer} </>}
                                </p>
                            )}
                            </div>
                        </div>

                        <div className="words-input mt-3">
                            <label>Ilość słów do przekazania:</label>
                            <input 
                            type='number'
                            className="form-control" 
                            max={fromWords}
                            min={0}
                            onChange={(e)=> {
                                const val = Number(e.target.value)
                                setWordsToTransfer(val > fromWords ? fromWords : val)
                            }
                                }/>

                        </div>
                        
                        
                        
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary"
                        onClick={onClose}>
                        Anuluj
                        </button>
                        <button className="btn btn-primary"
                        onClick={()=>toTransfer()}>
                        Przekaż
                        </button>
                    </div>
                </div>
            </div>
            </div>
        
    )
}